import { Bot, FileText, Users, ClipboardList, BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';

const suggestions = [
  {
    icon: Users,
    i18nKey: 'suggestion_hr',
    fallback: 'Show me employee statistics for this month',
  },
  {
    icon: FileText,
    i18nKey: 'suggestion_docs',
    fallback: 'Find and summarize the latest project documents',
  },
  {
    icon: ClipboardList,
    i18nKey: 'suggestion_tasks',
    fallback: 'Create a new task for the development team',
  },
  {
    icon: BarChart3,
    i18nKey: 'suggestion_analytics',
    fallback: 'Generate a performance report for Q1',
  },
];

export default function WelcomeScreen({ onSuggestionClick }) {
  const { t } = useTranslation('chat');

  return (
    <div className="flex flex-col items-center justify-center h-full px-4">
      <div className="flex size-16 items-center justify-center rounded-2xl bg-primary/10 text-primary mb-6">
        <Bot className="size-8" />
      </div>
      <h1 className="text-2xl font-semibold text-foreground mb-2">
        {t('welcome_title', 'Zehn AI Platform')}
      </h1>
      <p className="text-muted-foreground text-center mb-8 max-w-md">
        {t('welcome_subtitle', 'Ask me to help with HR, documents, tasks, analytics, and more')}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-xl">
        {suggestions.map((s) => (
          <Card
            key={s.i18nKey}
            className="cursor-pointer py-3 hover:bg-accent/50 transition-colors group"
            onClick={() => onSuggestionClick?.(t(s.i18nKey, s.fallback))}
          >
            <CardContent className="flex items-start gap-3 p-0">
              <s.icon className="size-4 mt-0.5 text-muted-foreground group-hover:text-primary transition-colors shrink-0" />
              <span className="text-sm text-foreground">{t(s.i18nKey, s.fallback)}</span>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
